// src/v3/navigation/points.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var PointsIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "PointsIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M18.6103 5.25844C17.4787 3.31875 15.93 2.25 14.25 2.25H9.75C8.07 2.25 6.52125 3.31875 5.38969 5.25844C4.33219 7.07063 3.75 9.46875 3.75 12C3.75 14.5312 4.33219 16.9294 5.38969 18.7416C6.52125 20.6813 8.07 21.75 9.75 21.75H14.25C15.93 21.75 17.4787 20.6813 18.6103 18.7416C19.6678 16.9294 20.25 14.5312 20.25 12C20.25 9.46875 19.6678 7.07063 18.6103 5.25844ZM18.7303 11.25H15.7303C15.6717 9.71096 15.3653 8.19145 14.8228 6.75H17.6906C18.2644 8.00438 18.6431 9.5625 18.7303 11.25ZM16.7991 5.25H14.1056C13.7924 4.70655 13.4146 4.2029 12.9806 3.75H14.25C15.1875 3.75 16.0688 4.3125 16.7991 5.25ZM5.25 12C5.25 7.52812 7.3125 3.75 9.75 3.75C12.1875 3.75 14.25 7.52812 14.25 12C14.25 16.4719 12.1875 20.25 9.75 20.25C7.3125 20.25 5.25 16.4719 5.25 12ZM14.25 20.25H12.9834C13.4174 19.7971 13.7952 19.2935 14.1084 18.75H16.8019C16.0688 19.6875 15.1875 20.25 14.25 20.25ZM17.6906 17.25H14.8237C15.3662 15.8085 15.6727 14.289 15.7313 12.75H18.7313C18.6431 14.4375 18.2644 15.9956 17.6906 17.25Z"
  }
) });

export {
  PointsIcon
};
